import React from 'react';
import { useTranslation } from 'react-i18next';
import './CampaignEnded.css';

function CampaignEnded() {
  const { t } = useTranslation();

  return (
    <div className="campaign-ended">
      <div className="campaign-ended-container">
        <div className="campaign-ended-icon">
          <span className="campaign-ended-check">✓</span>
        </div>
        <h1 className="campaign-ended-title">{t('campaignEnded.title')}</h1>
        <p className="campaign-ended-message">
          {t('campaignEnded.message')}
        </p>
        <p className="campaign-ended-subtitle">
          {t('campaignEnded.stayTuned')}
        </p>
      </div>
    </div>
  );
}

export default CampaignEnded;
